<section class="mt-2">
    <div class="action-btn px-4">
        <button class="mr-5" nz-button nzType="default" (click)="resetForm()">Reset</button>
        <button nz-button nzType="primary" (click)="saveRow()">Save</button>
    </div>
    <div class="add-catalog-title px-4">
        <h6>Sizes</h6>
    </div>
    <div class="form-container">
        <div class="mt-1 mb-3 d-flex justify-content-end px-1">
            <button nz-button nzType="primary" (click)="addRow()">Add New</button>
        </div>
        <div class="col-md-12">
            <span class="text-danger" *ngIf="invalidPair">
                Atleast One Size1-Size2 pair is duplicated.
            </span>
            <span class="text-danger" *ngIf="invalidList">
                Please enter atleast One Size to filter.
            </span>
            <nz-collapse class="mb-3" style="background-color: #ffff;" nzAccordion>

                <nz-collapse-panel [nzDisabled]="true" showArrow={false} [nzHeader]="customHeader"
                    [nzExpandedIcon]="customHeader" [nzActive]="true">
                    <div class="row d-flex align-items-center">
                        @for (panel of lotArrList; track panel) {
                        @if(panel.fieldType == 'input'){
                        <ng-container>
                            <div  class="col-md-4 position-relative mb-1" *ngIf="panel.placeholder === 'Enter Size1'">
                                <nz-select  [(ngModel)]="panel.value" (nzOnSearch)="onSearch($event, panel)"
                                    [maxlength]="3" (ngModelChange)="onSize1Change($event, panel)"
                                    nzPlaceHolder="Enter Size1" class="w-100 uppercase-select"
                                    (keydown)="blockNonUppercaseLetters($event)" [nzShowSearch]="true"
                                    [nzServerSearch]="true" #size1Select>

                                    @for (t of typeOptions; track t) {
                                    <nz-option [nzLabel]="t" [nzValue]="t"></nz-option>
                                    }
                                    @if (panel.value && !typeOptions.includes(panel.value)) {
                                    <nz-option [nzLabel]="panel.value" [nzValue]="panel.value"></nz-option>
                                    }
                                </nz-select>
                                <span *ngIf="panel.isMissingError" class="error-text mb-1">
                                    Size 1 is required
                                </span>
                            </div>
                            <div  class="col-md-4 position-relative mb-1 " *ngIf="panel.placeholder === 'Enter Size2'">
                                <nz-select  [(ngModel)]="panel.value" (nzOnSearch)="onSearch($event, panel)"
                                    (ngModelChange)="onSize2Change($event, panel);validateLotSizes()" nzPlaceHolder="Enter Size2"
                                    class="w-100" [nzShowSearch]="true"
                                    (keydown)="blockNonNumbers($event)" [nzServerSearch]="true"
                                    (keydown.tab)="handleSize2Tab($event, panel)">

                                    @for (option of panel.options; track option) {
                                    <nz-option [nzLabel]="option" [nzValue]="option"></nz-option>
                                    }
                                    @if (panel.value && !panel.options?.includes(panel.value)) {
                                    <nz-option [nzLabel]="panel.value" [nzValue]="panel.value"></nz-option>
                                    }
                                </nz-select>
                                <span *ngIf="panel.isMissingError" class="error-text">
                                    Size 2 is required
                                </span>
                            </div>
                        </ng-container>
                        }
                        @else if(panel.fieldType == 'button') {
                        <div class="col-md-2 mb-4">
                            @if(panel.id == 3){
                            <label style="height: 35px;" class="form-label">
                            </label> }
                            <button (click)="clearRow(panel)" style="height: 32px;" class="margin-right" nz-button
                                nzType="default">Clear</button>
                        </div>
                        }
                        }

                        <ng-template #customHeader>
                            <ng-container>
                                <div>
                                </div>
                            </ng-container>
                        </ng-template>
                    </div>
                </nz-collapse-panel>

            </nz-collapse>
        </div>
    </div>
</section>